<template>
  <div>
    <div class="people_box" v-if="showInput">
      <b v-if="showRenNumber">人数</b>
      <p>
        <b>亲，客人共&nbsp;&nbsp;</b>
        <el-input-number v-model="spotData.adult" size='mini' :min="0" label="成人" style="width:1.2rem"></el-input-number>
        &nbsp;&nbsp;成人&nbsp;&nbsp;
        <el-input-number v-model="spotData.children" size='mini' :min="0" label="儿童" style="width:1.2rem"></el-input-number>
        &nbsp;&nbsp;儿童&nbsp;&nbsp;
      </p>
    </div>
    <div v-else>

    </div>
  </div>
</template>

<script>
export default {
  props:{
    spotData:{
      type:Object,
      default: ()=>{return{}}
    },
    showInput:{
      type:Boolean,
      default:true
    },
    showRenNumber:{
      type:Boolean,
      default:true
    }
  }
}
</script>

<style lang="scss" scoped>
.people_box{
  background: #f7f7f7;
  border-radius: 5px;
  margin: 0.16rem 0;
  padding: 0.05rem 0.3rem 0.05rem 0.05rem;
  font-size: 0.12rem;
  display: flex;
  color: #000;
  >b{
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #e17148;
    color: #fff;
    font-size: 0.18rem;
    text-align: center;
    line-height: 0.5rem;
    font-weight: normal;
    margin-right: 0.3rem;
  }
  >p{
    display: flex;
    align-items: center;
  }
}
</style>